import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css"; // 👈 importa o Bootstrap globalmente
import "./assets/styles/reset.css";
import "./assets/styles/base.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FullBanner } from "./components/FullBanner";
import { PlatformsSlide } from "./components/PlatformsSlide";
import { TourDates } from "./components/TourDates";
import { News } from "./components/News";
import { Albuns } from "./components/Albuns";
import { Follow } from "./components/Follow";
import { Media } from "./components/Media";
import { About } from "./components/About";
import { useEffect, useState } from "react";
import { initFluid } from "smokey-fluid-cursor";
import { SmokeOverlay } from "./components/SmokeOverlay";
import { getCurrentLocale, getTranslations } from "./i18n";
import { AdminApp } from "./admin/AdminApp";

const isTouchDevice = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  return window.matchMedia("(pointer: coarse)").matches;
};

function PublicSite() {
  const locale = getCurrentLocale();
  const content = getTranslations(locale);
  const [isTouch, setIsTouch] = useState(isTouchDevice);
  const [showDesktopSmoke, setShowDesktopSmoke] = useState(false);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }

    const pointerQuery = window.matchMedia("(pointer: coarse)");
    const updatePointerMode = () => setIsTouch(pointerQuery.matches);

    updatePointerMode();
    pointerQuery.addEventListener("change", updatePointerMode);

    return () => {
      pointerQuery.removeEventListener("change", updatePointerMode);
    };
  }, []);

  useEffect(() => {
    if (!isTouch) {
      initFluid();

      const smokeTimer = window.setTimeout(() => {
        setShowDesktopSmoke(true);
      }, 900);

      return () => {
        window.clearTimeout(smokeTimer);
        setShowDesktopSmoke(false);
      };
    }

    setShowDesktopSmoke(false);
    return undefined;
  }, [isTouch]);

  return (
    <>
      {!isTouch && (
        <canvas
          id="smokey-fluid-canvas"
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            pointerEvents: "none",
            zIndex: 9999,
            opacity: showDesktopSmoke ? 1 : 0,
            transition: "opacity 1200ms ease",
          }}
        />
      )}
      {isTouch && (
        <SmokeOverlay
          intensity={0.95}
          maxFps={30}
          dprCap={1}
          opacity={0.68}
          mixBlendMode="screen"
          interactive={false}
          colorStrength={0.08}
          zIndex={12}
        />
      )}
      
      <div className="App">
        <Header
          className="header-instance"
          locale={locale}
          content={content}
        />
        <div class="containt">
          <FullBanner className="full-banner-instance" content={content} />
          <PlatformsSlide />
          <TourDates content={content} />
          <About content={content} />
          <Media content={content} />
          <Albuns content={content} />
          <Follow content={content} />
          <News content={content} />
        </div>
        <Footer content={content} />
      </div>
    </>
  );
}

function App() {
  const isAdminRoute =
    typeof window !== "undefined" &&
    window.location.pathname.replace(/\/+$/, "") === "/admin";

  return isAdminRoute ? <AdminApp /> : <PublicSite />;
}

export default App;
